import React from "react";
import { Home } from "lucide-react";
import {
  CommunicationIcon,
  MonitorIcon,
  ObservatorioIcon,
  ReportIcon,
  NotificationIcon,
  ForecastIcon,
  SilentNotificationIcon,
  UserIcon
} from "@ui";
import { NavigationItem } from "./NavigationItem";
import { useMessageCounter } from "@shared/contexts/MessageCounterContext";
import { ROUTES } from "@shared/constants/routes.constants";

interface NavigationProps {
  isOpen: boolean;
}

export const Navigation: React.FC<NavigationProps> = ({ isOpen }) => {
  const { unreadCount, pluvialAlertsCount } = useMessageCounter();
  
  const navigationItems = [
    {
      icon: NotificationIcon,
      label: "Notificaciones",
      path: ROUTES.MAIN.NOTIFICATIONS,
      colorActive: "#ffe6fc",
      requiredScope: null,
      bullet: unreadCount,
    },
    {
      icon: Home,
      label: "Home",
      path: ROUTES.MAIN.HOME,
      colorActive: "#abeaf6",
      requiredScope: null,
    },
    {
      icon: MonitorIcon,
      label: "Monitor de riesgos",
      path: ROUTES.MAIN.MONITOR,
      colorActive: "#ffe4b2",
      requiredScope: null,
      bullet: pluvialAlertsCount,
    },
    {
      icon: CommunicationIcon,
      label: "Comunicación ciudadana",
      path: ROUTES.COMMUNICATION.ROOT,
      colorActive: "#edccff",
      requiredScope: "read:alert" as const,
    },
    {
      icon: ObservatorioIcon,
      label: "Observatorio",
      path: ROUTES.OBSERVATORY.ROOT,
      colorActive: "#abeaf6",
      requiredScope: null,
    },
    {
      icon: ReportIcon,
      label: "Reportes",
      path: ROUTES.REPORTS.ROOT,
      colorActive: "#ffe6fc",
      requiredScope: null,
    },
    {
      icon: ForecastIcon,
      label: "SIGEM",
      path: "https://sigem.jaliscoalerta.com/",
      colorActive: "#ffe6fc",
      requiredScope: null,
    },
    {
      icon: UserIcon,
      label: "Usuarios",
      path: ROUTES.MAIN.USERS,
      colorActive: "#ffe6fc",
      requiredScope: "create:user" as const,
    },
    {
      icon: SilentNotificationIcon,
      label: "Notificaciones silenciosas",
      path: ROUTES.COMMUNICATION.PHENOMENON_TYPES.SILENT,
      colorActive: "#ffe6fc",
      requiredScope: "all:silent" as const,
    },
    {
      icon: SilentNotificationIcon,
      label: "Silenciosas pronósticos",
      path: ROUTES.COMMUNICATION.CREATE_MULTIPLE_FORECAST,
      colorActive: "#ffe6fc",
      requiredScope: "all:silent" as const,
    },
  ];

  return (
    <nav className="flex-1 p-4">
      <ul className="space-y-1">
        {navigationItems.map((item) => (
          <NavigationItem
            key={item.path}
            icon={item.icon}
            label={item.label}
            path={item.path}
            colorActive={item.colorActive}
            requiredScope={item.requiredScope}
            isOpen={isOpen}
            bullet={item.bullet}
          />
        ))}
      </ul>
    </nav>
  );
};
